import React from "react";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../../../redux/initialStoreState";
import { useDispatchWrapper } from "../../../../../../hooks";
import {
  clearCommAutomobileVehicleState,
  fetchCommAutomobileVehicleListAsync,
} from "../../../../../../redux/commAutoPolicy/commAutoVehicle/commAutoVehicleActions";

export const useCommAutoVehcileInfo = (customerPolicyId?: number) => {
  const dispatch = useDispatchWrapper();
  const { vehiclesList } = useSelector(
    (storeState: IStoreState) => storeState.commAuto.vehicle.VehicleInformation
  );

  const vehcileDropdown = React.useMemo(() => {
    return vehiclesList.map((item) => {
      return {
        label: `${item.incremental_number || "--"} (VIN: ${
          item.vin || "N/A"
        }, Year: ${item.year}, Make: ${item.make}, Model: ${item.model} )`,
        value: String(item.incremental_number || ""),
      };
    });
  }, [vehiclesList]);

  const refreshData = () => {
    if (customerPolicyId) {
      dispatch(fetchCommAutomobileVehicleListAsync(Number(customerPolicyId)));
    }
  }

  React.useEffect(() => {
    if (customerPolicyId) {
      dispatch(fetchCommAutomobileVehicleListAsync(Number(customerPolicyId)));
    }
    return () => {
      dispatch(clearCommAutomobileVehicleState());
    };
  }, [customerPolicyId]);

  return { vehcileDropdown, vehiclesList, refreshData };
};
